import React from 'react';
import { Navbar } from '../components/Navbar';
import { TrustBar } from '../components/TrustBar';
import { RelatedFeatures } from '../components/RelatedFeatures';
import { Footer } from '../components/Footer';
import { ScraperHero } from '../components/google-maps-scraper/ScraperHero';
import { ScraperShowcase } from '../components/google-maps-scraper/ScraperShowcase';
import { ScraperWorkflow } from '../components/google-maps-scraper/ScraperWorkflow';
import { ScraperValueProps } from '../components/google-maps-scraper/ScraperValueProps';
import { ScraperProductTour } from '../components/google-maps-scraper/ScraperProductTour';
import { DataFieldsSection } from '../components/google-maps-scraper/DataFieldsSection';
import { ScraperDemo } from '../components/google-maps-scraper/ScraperDemo';
import { ScraperComparison } from '../components/google-maps-scraper/ScraperComparison';
import { ScraperPricing } from '../components/google-maps-scraper/ScraperPricing';
import { ScraperUseCases } from '../components/google-maps-scraper/ScraperUseCases';
import { ScraperFAQ } from '../components/google-maps-scraper/ScraperFAQ';
import { ScraperCta } from '../components/google-maps-scraper/ScraperCta';
import { DatabaseIcon, BookOpenIcon } from 'lucide-react';
const scraperFeatures = [{
  title: 'Restaurant contacts database',
  description: 'Access restaurant contacts with reviews and ratings.',
  href: 'https://openmart.com/data/restaurants',
  cta: 'Explore restaurants',
  type: 'Database',
  color: 'purple' as const,
  icon: DatabaseIcon
}, {
  title: 'Car dealer contacts database',
  description: 'Find car dealerships with location and contact info.',
  href: 'https://openmart.com/data/car-dealer',
  cta: 'Explore car dealers',
  type: 'Database',
  color: 'purple' as const,
  icon: DatabaseIcon
}, {
  title: 'Cafe contacts database',
  description: 'Discover cafes and coffee shops with reviews.',
  href: 'https://openmart.com/data/cafe',
  cta: 'Explore cafes',
  type: 'Database',
  color: 'purple' as const,
  icon: DatabaseIcon
}, {
  title: 'Beauty salon contacts database',
  description: 'Access beauty salons with ratings and services.',
  href: 'https://openmart.com/data/beauty-salons',
  cta: 'Explore beauty salons',
  type: 'Database',
  color: 'purple' as const,
  icon: DatabaseIcon
}, {
  title: 'Nail salon contacts database',
  description: 'Find nail salons with contact details and reviews.',
  href: 'https://openmart.com/data/nail-salons',
  cta: 'Explore nail salons',
  type: 'Database',
  color: 'purple' as const,
  icon: DatabaseIcon
}, {
  title: 'Getting started guide',
  description: 'Learn how to use Openmart to scrape Google Maps.',
  href: 'https://openmart.com/product-tutorials/onboarding',
  cta: 'Read guide',
  type: 'Tutorial',
  color: 'blue' as const,
  icon: BookOpenIcon
}];
export function GoogleMapsScraper() {
  return <div className="min-h-screen bg-white font-sans selection:bg-blue-100 selection:text-blue-900" data-id="element-4382">
      <Navbar data-id="element-4383" />
      <main data-id="element-4384">
        <ScraperHero data-id="element-4385" />
        <TrustBar data-id="element-4386" />
        <ScraperShowcase data-id="element-4387" />
        <ScraperWorkflow data-id="element-4388" />
        <ScraperValueProps data-id="element-4389" />
        <ScraperProductTour data-id="element-4390" />
        <DataFieldsSection data-id="element-4391" />
        <ScraperDemo data-id="element-4392" />
        <ScraperComparison data-id="element-4393" />
        <ScraperPricing data-id="element-4394" />
        <ScraperUseCases data-id="element-4395" />
        <ScraperFAQ data-id="element-4396" />
        <RelatedFeatures features={scraperFeatures} data-id="element-4397" />
        <ScraperCta data-id="element-4398" />
      </main>
      <Footer data-id="element-4399" />
    </div>;
}